// extracted by mini-css-extract-plugin
export var actionText = "_mo-4";
export var container = "_mo-0";
export var leftSection = "_mo-1";
export var rightSection = "_mo-2";
export var settingsButton = "_mo-6";
export var settingsIcon = "_mo-7";
export var shortcut = "_mo-5";
export var shortcutGroup = "_mo-3";